export default __webpack_public_path__ + "static/media/q2.edb453c7.png";